import CellHero from "../components/CellHero";
import CellFocus from "../components/CellFocus";
import CellPathwayNav from "../components/CellPathwayNav";
import CellLeadership from "../components/CellLeadership";
import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { Link } from "react-router-dom";

export default function MarketingMerchandisingCellPage() {
  return (
    <main className="min-h-screen">
      <CellHero
        name="Marketing & Merchandising Cell"
        tagline="Supply Chain Sync, Costing, and Market Intelligence"
        description="The Marketing & Merchandising Cell bridges the gap between factory operations and global market demands. It ensures that innovation is not only technically sound but also commercially positioned, competitively costed, and aligned with buyer expectations."
        icon="ri-shopping-cart-2-line"
      />

      <CellFocus
        focus={[
          "Supply chain operation synchronization",
          "Costing standardization & value engineering",
          "Buyer evaluation & market intelligence",
          "Product positioning for global markets",
        ]}
        description="Merchandising is where engineering meets economics. This cell develops frameworks for accurate costing, buyer-ready product positioning, and supply chain synchronization that reduces lead times and increases win rates in competitive sourcing environments."
      />

      <CellLeadership
        chiefCatalyst={{
          name: "Engr. Saiful Islam Khan",
          designation: "Managing Director, Essential Clothing Ltd.",
        }}
        moderators={[
          {
            name: "Shihab Nur",
            designation: "Chief Sourcing & Merchandising Officer, Green 2 Garments",
          },
        ]}
      />

      {/* Related Programmes */}
      <section className="bg-tie-navy py-16 md:py-24">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <ScrollReveal>
              <div className="text-center mb-8 md:mb-12">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-white/10 border border-white/20 mb-4 md:mb-5">
                  <span className="text-xs font-semibold text-white/80 uppercase tracking-wider">
                    / Related Programmes
                  </span>
                </div>
                <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight">
                  Commercial Innovation Enablers
                </h2>
              </div>
            </ScrollReveal>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {[
                { name: "PIIC", desc: "Merchandising-focused Innovation Circles for costing and buyer sync", route: "/piic" },
                { name: "Training", desc: "Professional certification for merchandisers and marketing teams", route: "/training" },
                { name: "Experts", desc: "Market intelligence and costing specialists on demand", route: "/experts" },
                { name: "PIARC", desc: "Research on supply chain optimization and buyer behavior", route: "/piarc" },
              ].map((prog, index) => (
                <ScrollReveal key={prog.name} delay={index * 100}>
                  <Link to={prog.route} className="group block p-5 md:p-6 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-tie-teal/30 transition-all duration-300">
                    <h3 className="text-base md:text-lg font-semibold text-white mb-2">{prog.name}</h3>
                    <p className="text-sm text-white/60">{prog.desc}</p>
                    <span className="inline-flex items-center mt-3 text-sm font-medium text-tie-teal-light group-hover:text-tie-teal transition-colors">
                      Learn more <i className="ri-arrow-right-line ml-1.5 text-xs group-hover:translate-x-1 transition-transform" />
                    </span>
                  </Link>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CellPathwayNav />
    </main>
  );
}